<template>
  <div id="monitoring-vessel-engine">
    <div id="monitoring-vessel-engine-header">
      <div id="header-text" class="sdf-text-22-700-white">
        トレンドデータレポート
      </div>
      <div class="vessel-communication-channel-area">
        <vessel-communication-channel />
      </div>
    </div>

    <input-display-condition
      @refreshChannelData="refreshChannelData"
      @resetLiveChannelZoom="resetLiveChannelZoom"
      :alertEventCallable="false"
      ref="engineDisplayCondition"
    ></input-display-condition>
    <engine-data-details
      @setTimeDisplay="setTimeDisplay"
      @setLiveChannelTime="setLiveChannelTime"
      ref="engineDataDetails"
    ></engine-data-details>
  </div>

</template>

<script>
import InputDisplayCondition from "../components/InputDisplayCondition";
import VesselCommunicationChannel from "../components/VesselCommunicationChannel";
import EngineDataDetails from "./components/EngineDataDetails";
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"
import SecureDataflowService from "@/services/secureDataflowService";
import {createNamespacedHelpers} from "vuex"
import Vue from "vue"
import moment from "moment"
import {
  StoreCommonsMixin,
  StoreMenuMixin,
  MappingTableMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

const { mapGetters, mapActions, mapState } = createNamespacedHelpers("monitoringVesselEngine");

export default {
  name: "monitoringVesselEngine",
  mixins: [
    StoreCommonsMixin,
    StoreMenuMixin,
    SecureDataflowMixin,
    MappingTableMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {
    InputDisplayCondition,
    EngineDataDetails,
    VesselCommunicationChannel
  },
  data() {
    return {
      intervalId: null,
      timer: null,
      maneuveringLastUpdatedAt: null,
      maneuveringLastUpdateAtString: null,
      engineLastUpdatedAt: null,
      lastUpdateAt: null,
    }
  },
  watch: {
    channelDataManeuvering(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.maneuveringLastUpdatedAt = moment.unix(
          val.last_updated_at.seconds
        );
        this.updateStateTime();
      }
    },
    channelDataEngine(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.engineLastUpdatedAt = moment.unix(val.last_updated_at.seconds);
        this.updateStateTime();
      }
    }
  },
  computed: {
    operationMode() {
      if (this.channelDataManeuvering) {
        return `${this.getOperationModeLabel(
          this.channelDataManeuvering.SB44.vs
        )}`;
      }
    },
  },
  methods: {
    ...mapActions(["initializeCustomChannelIds"]),
    refreshChannelData(){
      this.$refs.engineDataDetails.refreshChannelData(true);
    },
    resetLiveChannelZoom() {
      this.$refs.engineDataDetails.resetLiveChannelZoom()
    },
    setTimeDisplay(time) {
      this.$refs.engineDisplayCondition.setTimeDisplay(time.start_time, time.end_time)
    },
    setLiveChannelTime() {
      this.$refs.engineDisplayCondition.setChannelTime("live")
    },


    updateStateTime() {
      // 最終更新時刻は操船データの最終更新時刻を採用
      if (this.maneuveringLastUpdatedAt) {
        this.maneuveringLastUpdateAtString = this.maneuveringLastUpdatedAt
          .local()
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        this.maneuveringLastUpdateAtString = "--/--/-- --:--:--";
      }
      
      if (this.maneuveringLastUpdatedAt && this.engineLastUpdatedAt) {
        if (this.maneuveringLastUpdatedAt.isAfter(this.engineLastUpdatedAt)) {
          this.lastUpdateAt = this.maneuveringLastUpdatedAt;
        } else {
          this.lastUpdateAt = this.engineLastUpdatedAt;
        }
        this.setWatchConnectionState();
      }
    },
    setWatchConnectionState() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.isDisconnect()) {
        this.setDisconnectState4gVSAT()
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable 4G/VSA connection, last update at ${this.lastUpdateAt.local()}`
        // );
        this.SET_CONNECTING_STATE_4G_VSAT({
          isDisconnect: false,
          localTime: this.lastUpdateAt.local()
        });
        this.setTimerWatchConnectionState();
      }
    },
    setTimerWatchConnectionState() {
      this.timer = setTimeout(() => {
        this.setDisconnectState4gVSAT()
      }, 120000);
    },
    isDisconnect() {
      // 2分超えているかどうか
      return moment().diff(this.lastUpdateAt, "minutes") >= 2;
    },
    setDisconnectState4gVSAT() {
      Vue.$log.warn(
        `[SDF] Disconnect 4G/VSAT, last update at ${this.lastUpdateAt.local()}`
      );
      this.SET_CONNECTING_STATE_4G_VSAT({
        isDisconnect: true,
        localTime: this.lastUpdateAt.local()
      });
    },
  },
  async created() {

    await this.initializeCustomChannelIds();
/*
    let vessel = await SecureDataflowService.getVessel();
    if (typeof vessel === "undefined") {
      this.SET_SHOW_DIALOG_SELECT_VESSEL(true)
    } else {
      let payload = {
        vesselInfo: vessel.vessel_info,
        maneuveringOriginId: vessel.maneuvering_origin_id,
        engineOriginId: vessel.engine_origin_id,
        alertOriginId: vessel.alert_origin_id,
      };
      await this.setVesselInfoAndVersions(payload);
    }
*/
    let vessel = await SecureDataflowService.getVessel();
    if (typeof vessel === "undefined") {
      this.SET_SHOW_DIALOG_SELECT_VESSEL(true);
    } else {
      let payload = {
        vesselInfo: vessel.vessel_info,
        maneuveringOriginId: vessel.maneuvering_origin_id,
        engineOriginId: vessel.engine_origin_id,
        alertOriginId: vessel.alert_origin_id
      };
      await this.setVesselInfoAndVersions(payload);
      await this.setChannelMaster({
        vesselId: vessel.vessel_info.id,
        params: {
          version_id: this.engineVersion.id
        }
      });
      await this.setOwnVessels()
    }

    this.getInitialFOFlow({
      vesselId: this.vesselInfo.id,
      versionName: this.engineVersion.name
    })

    this.subscribeChannelDataManeuvering({
      vesselId: this.vesselInfo.id,
      versionName: this.maneuveringVersion.name
    });

    this.subscribeChannelDataEngine({
      vesselId: this.vesselInfo.id,
      versionName: this.engineVersion.name
    });

    this.subscribeChannelDataAlert({
      vesselId: this.vesselInfo.id,
      versionName: this.alertVersion.name
    });
  },
  mounted() {
    this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "secureDataflow");
    let routerViewClass = document.getElementsByClassName("router-view");
    routerViewClass[0].style.padding = "0.0rem";
  },
  beforeDestroy() {
    this.resetStateOfMonitoringVesselManeuvering();
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/secure-dataflow/_variables.scss";
.vessel-communication-channel-area {
  margin-right: 40px;
}
#monitoring-vessel-engine-header {
  width: 100%;
  height: 83px;
  background: #09151C;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  align-items: center;
}

#header-text {
  margin-left: 120px;
}

</style>
